import { ROUTES } from '@/routes/routes'

/**
 * Ensures redirectTo is a relative path under /app/ to prevent open-redirect attacks.
 */
export function getSafeRedirectPath(redirectTo: string | null | undefined): string {
  if (redirectTo && redirectTo.startsWith('/app/')) {
    return redirectTo
  }
  return ROUTES.APP.DASHBOARD
}
